import NavBar from "@/components/site/NavBar";
import Hero from "@/components/site/Hero";
import VturbPlayer from "@/components/site/VturbPlayer";
import AttorneyBar from "@/components/site/AttorneyBar";
import FearSection from "@/components/site/FearSection";
import FounderStory from "@/components/site/FounderStory";
import GoogleReviews from "@/components/site/GoogleReviews";
import Testimonials from "@/components/site/Testimonials";
import FinalCTA from "@/components/site/FinalCTA";
import Footer from "@/components/site/Footer";

const headline = (
  <>
    Getting married in OC?{" "}
    <span className="italic text-teal">Protect what you&rsquo;ve built.</span>
  </>
);
const subhead = (
  <>
    A prenuptial agreement isn&rsquo;t about distrust — it&rsquo;s about{" "}
    <span className="text-ink font-medium">clarity</span>.{" "}
    <span className="text-ink font-medium">Binoye Jos, Esq.</span> and the JOS
    Family Law team draft prenups and postnups in Orange County that are
    legally binding to protect what you&rsquo;ve built, based on what you want
    to accomplish. Do you believe it&rsquo;s worth protecting your assets? If
    so, contact us.
  </>
);
const pullquote = (
  <>
    Smart couples protect their marriage like their most valuable asset.{" "}
    <span className="italic text-teal">
      Secure your future and focus on love. Let us protect what you build
      together.
    </span>
  </>
);
const statBar = [
  { num: "80+", label: "Prenups Drafted" },
  { num: "100%", label: "Confidential Process" },
  { num: "1:1", label: "Attorney Attention" },
];

export default function PrenupVSLSplit() {
  return (
    <main data-testid="prenup-vsl-split-page" className="relative bg-paper text-ink">
      <NavBar />
      <Hero
        headline={headline}
        subhead={subhead}
        pullquote={pullquote}
        pullquoteLabel="Our Promise"
        source="Prenup VSL v2"
        statBar={statBar}
        statHeading="How We Work"
        statContext="Every prenup is drafted with confidentiality and one-on-one attorney attention — no assembly-line templates, no rushed forms."
        compact
      />
      <VturbPlayer videoId="6a59ce7ca44a1e6feb43e037" />
      <AttorneyBar />
      <FearSection />
      <FounderStory />
      <GoogleReviews />
      <Testimonials />
      <FinalCTA source="Prenup VSL v2" />
      <Footer />
    </main>
  );
}
